import { useCallback } from 'react'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import moment from 'moment'
import { func, string, array, bool, object } from 'prop-types'
import { CvsAvatar } from '@components'

function getCellContent(col, row) {
  const value = row[col.lookup] || col.placeholder
  let transformedValue = value
  switch (col.type) {
    case 'avatar':
      transformedValue = (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <CvsAvatar user={row} />
          <span>{row.name}</span>
        </span>
      )
      break
    case 'number':
      transformedValue = value ? Intl.NumberFormat().format(value) : 0
      break
    case 'date':
      transformedValue = value ? moment(value).format('MM/DD/YY') : null
      break
    case 'boolean':
      transformedValue = value ? 'true' : 'false'
      break
    case 'list':
      transformedValue = value.map(f => f.name).join(', ')
      break
    case 'target':
      transformedValue = value
        .map(targetField => `${targetField.target.name} > ${targetField.name}`)
        .join(', ')
      break
    case 'component':
      transformedValue = <col.component col={col} row={row} />
      break
    default:
      transformedValue = value
      break
  }
  return transformedValue
}

export const CvsNoCheckboxRow = ({
  handleClick = () => {},
  columns,
  row,
  keyField,
  isItemSelected = false,
  labelId,
}) => {
  const onClick = useCallback(() => {
    handleClick(row[keyField])
  }, [handleClick, row, keyField])

  return (
    <TableRow
      hover
      style={{ cursor: 'pointer' }}
      onClick={onClick}
      aria-checked={isItemSelected}
      tabIndex={-1}
      selected={isItemSelected}
    >
      {columns.map(col => {
        return (
          <TableCell
            style={{ left: '200px' }}
            component="th"
            key={row[keyField] + row[col.lookup] + col.label}
            id={labelId}
          >
            {getCellContent(col, row)}
          </TableCell>
        )
      })}
    </TableRow>
  )
}

CvsNoCheckboxRow.propTypes = {
  handleClick: func,
  row: object.isRequired,
  columns: array.isRequired,
  keyField: string.isRequired,
  isItemSelected: bool,
  labelId: string.isRequired,
}
